export let Gender = /*#__PURE__*/function (Gender) {
  Gender["Male"] = "male";
  Gender["Female"] = "female";
  Gender["NonBinary"] = "nonBinary";
  return Gender;
}({});